var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-conversation__loader"},[_c('div',{staticClass:"chat-conversation__loader-content"},[_c('loader-circle-icon',{ref:"chatLoader"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }